export function getStandardLayerProps(config) {
  return {
    title: config.title,
    visible: config.visible ?? false,
    type: config.base ? 'base' : undefined,
    ...config.layer,
  }
}
